import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { NgRedux } from '@angular-redux/store';
import { ActivatedRoute } from '@angular/router';
import { TrackingJsonService, UserService } from '../../../api/services';
import { APP_CONFIG } from '../../../api/config';
import { IAppState, IAppConfig } from '../../../store';
import { WindowRef, scrollTo } from '../../../common';
import { SiteURLUtils, SiteURL } from '../../../common/site.url.utils';
import { Title } from '@angular/platform-browser';
import { Reservation } from '../../../api/model/reservation/reservation.model';
import { ActionHandler } from '../../../store/action.handler';
import { AppAction } from '../../../store/interfaces/IAppState';
import { MessageCategory } from '../../../api/model/message/message-category.model';
import { CancelReservationDelegate } from '../../../api/delegates/cancel-reservation.delegate';
import { MessagesUtil } from '../../../common/messages.util';
import { Unsubscribe } from 'redux';
import { Hotel } from '../../../api/model/hotel/hotel.model';
import * as uriTemplate from 'urijs/src/URITemplate';
import { RouteNames } from '../../../api/enums';

@Component({
  selector: 'stay-mgmt-cancel-conf',
  templateUrl: './cancel-conf.component.html',
  styleUrls: ['./cancel-conf.component.scss']
})
export class CancelConfComponent implements OnInit, OnDestroy {
  error: any = null;
  reservation: Reservation = null;
  reservationId: string;
  lastName: string;
  state: IAppState;
  hotel: Hotel;
  messages: { [key: string]: string };
  cancelConfTitleElement: 'conf-title';
  messageCategory: MessageCategory;
  SPND_BRAND = 'nd';

  unsubscribe: Unsubscribe;

  constructor(
    @Inject(APP_CONFIG) protected appConfig: IAppConfig,
    private _ngRedux: NgRedux<IAppState>,
    private _cancelRes: CancelReservationDelegate,
    private _activatedRoute: ActivatedRoute,
    private _titleService: Title,
    private _trackingJson: TrackingJsonService,
    private _userService: UserService,
    private _window: WindowRef
  ) {

    this._activatedRoute.params.subscribe(params => {
      this.reservationId = params['id'];
      this.lastName = params['lastName'];
    });
    this._titleService.setTitle('IHG | Cancel Reservation Confirmation');
  }

  ngOnInit() {
    //  FIND OUT WHO WE ARE BEFORE DOING ANYTHING ELSE
    this._userService.me();
    //  START TRACKING JSON
    this._trackingJson.subscribeRoute(RouteNames.CancelConfirmation);
    //  THIS SETS TOP LEVEL COMPONENT VARIABLES BECAUSE USING select() WAS CAUSING PROBLEMS
    this.updateFromState();
    //  CHECK TO SEE IF ANYTHING IS IN STATE...IF NOT POPULATE HOTEL RES ONLY
    // Check to see if we already have a reservation from the state
    if (this.reservation === null) {
      //  THIS MAKES ALL THE CALLS TO APIS TO POPULATE STATE
      this._cancelRes.fetchReservation(this.reservationId, this.lastName, RouteNames.CancelConfirmation);
    }
    //  THIS IS THE REDUX SUBSCRIPTION THAT GETS CALLED EVERYTIME STATE IS CHANGED
    //  IT THEN REHYDRATES WHATEVER TOP LEVEL VARIABLES HAVE BEEN CHANGED
    //  AND PUSHES THOSE CHANGES INTO THE CHILD COMPONENTS
    this.unsubscribe = this._ngRedux.subscribe(() => {
      this.updateFromState();
    });
    this.messageCategory = MessageCategory.CANCEL_CONFIRMATION;
    scrollTo(this.cancelConfTitleElement, false);
  }

  ngOnDestroy() {
    this._trackingJson.unsubscribeRoute(RouteNames.CancelConfirmation);
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  makeAnotherReservation(): void {
    SiteURLUtils.redirectToSiteUrl(this.appConfig, SiteURL.HOMEPAGE_6C);
  }

  onLinkClick(): void {

    const removeChildNode = (node) => {
      node && node.parentElement.removeChild(node);
    };

    const popup = this._window.nativeWindow.open('', 'Print View', 'scrollbars=1,height=' + this._window.nativeWindow.innerHeight + ',width=' + this._window.nativeWindow.innerWidth +
      ',top=20,location=0,menubar=0,status=0,titlebar=0,toolbar=0');
    const popUpDom = document.createElement('div');
    popUpDom.appendChild(document.body.cloneNode(true));
    const headerAndFooter = popUpDom.querySelectorAll('header, footer');

    // remove header and footer
    for (let i = 0, j = headerAndFooter.length; i < j; i++) {
      removeChildNode(headerAndFooter[i]);
    }

    // Remove feedback link
    removeChildNode(popUpDom.querySelector('#oo_tab'));

    // Display IHG Logo
    const ihgLogoElement = popUpDom.querySelector('.print-view');

    if (ihgLogoElement) {
      ihgLogoElement.className = ' d-block';
    }

    // Add special class for Cancel Confirmation title
    const cancelConfirmationTitleElement = popUpDom.querySelector('.cancel-title');

    if (cancelConfirmationTitleElement) {
      cancelConfirmationTitleElement.className += ' print-conf-title';
    }

    // Remove confirmation print message
    const cancelConfirmationPrintMessageElement = popUpDom.querySelector('.print-text');

    if (cancelConfirmationPrintMessageElement) {
      cancelConfirmationPrintMessageElement.className += ' d-none';
    }

    // Remove make another reservation & view my account buttons
    const cancelConfirmationButtonElement = popUpDom.querySelector('.flexbox-button');

    if (cancelConfirmationButtonElement) {
      cancelConfirmationButtonElement.className = ' d-none';
    }

    const printScript = document.createElement('script');
    printScript.type = 'text/javascript'
    printScript.innerHTML = `window.print && window.print();`;

    popUpDom.appendChild(printScript);
    popup.document && popup.document.write(popUpDom.innerHTML);

  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    if (!this.state) {
      return;
    }
    this.messages = MessagesUtil.filterTranslations(this.state.translations, 'cancelconfirmation');
    this.reservation = this.state.reservation;
    this.hotel = this.state.hotel;
    ActionHandler.handleError(this.state, AppAction.GET_RESERVATION, () => {
      this.error = this.state.error;
    });
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/cancel-conf/cancel-conf/cancel-conf.component.ts